import React from "react";

function Skeleton({ className, ...props }) {
    return (
        <div
            className={`animate-pulse rounded-md bg-slate-200 dark:bg-slate-700/50 ${className || ''}`}
            {...props}
        />
    );
}

export default Skeleton;
